import { ReactComponent as Caret } from '@common/icons/Caret.svg';
import Carousel from '@lib/Carousel';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';

import Image from '../../../lib-components/Image';

interface VerticalGalleryProps {
  images: string[];
}

const VerticalGallery: React.FC<VerticalGalleryProps> = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(images[0] || '');
  useEffect(() => {
    setSelectedImage(images[0]);
  }, [images]);
  return (
    <div className="flex items-stretch">
      <div className="w-75 h-260 mr-18">
        <Carousel
          isVertical
          items={images}
          renderSlide={({ chunkedItem, chunkBy }) => {
            const images = chunkedItem as string[];
            return (
              <div className={'flex h-full flex-col py-20 justify-around'}>
                {images.map((image, index) => (
                  <div
                    key={index}
                    className={classnames('w-40 h-40 flex justify-center rounded border overflow-hidden', {
                      'border-gallery-selected shadow-gallerHighlight cursor-not-allowed': selectedImage === image,
                      'border-gallery-normal cursor-pointer': selectedImage !== image,
                    })}
                  >
                    <Image src={image} alt="Other Image" onClick={() => setSelectedImage(image)} />
                  </div>
                ))}
                {[...Array(chunkBy - images.length)].map((key) => (
                  <div key={key} className="h-40 w-40" />
                ))}
              </div>
            );
          }}
          breakpoints={[{ width: 0, chunkBy: 4 }]}
          renderControls={({ gotoPrevious, gotoNext }) => {
            return (
              <div>
                <div className="absolute left-0 top-0 w-full flex justify-center">
                  <button className="focus:outline-none" onClick={() => gotoPrevious()}>
                    <Caret className="transform rotate-180" />
                  </button>
                </div>
                <div className="absolute left-0 bottom-0 w-full flex justify-center">
                  <button className="focus:outline-none" onClick={() => gotoNext()}>
                    <Caret />
                  </button>
                </div>
              </div>
            );
          }}
        />
      </div>
      <div className="flex-grow h-260 flex justify-center rounded shadow-galleryBig overflow-hidden">
        <Image src={selectedImage} alt="Selected Image" className="rounded" />
      </div>
    </div>
  );
};

export default VerticalGallery;
